import { useFormContext } from 'react-hook-form';
import { ButtonPrimary } from '../../../../../../components/ButtonPrimary';
import styles from '../SetupFarma.module.scss';
import { SetupFarmaFormValues } from '../schema';

type SetupFarmaFooterProps = {
  onSave: (values: SetupFarmaFormValues) => void;
  isUpdating: boolean;
};

export const SetupFarmaFooter = ({ onSave, isUpdating }: SetupFarmaFooterProps) => {
  const { handleSubmit, reset } = useFormContext<SetupFarmaFormValues>();

  return (
    <div className={styles.footer}>
      <ButtonPrimary type="button" theme="ghost" disabled={isUpdating} onClick={() => reset()}>
        cancelar
      </ButtonPrimary>
      <ButtonPrimary type="button" isLoading={isUpdating} onClick={handleSubmit(onSave)}>
        salvar
      </ButtonPrimary>
    </div>
  );
};
